import { withdrawTypes } from '@/types';
import create from 'zustand';

export type WithdrawStore = {
  withdraw: withdrawTypes.Withdraw[];
  setWithdraw: (data: withdrawTypes.Withdraw[]) => void;
  addWithdraw: (data: withdrawTypes.Withdraw) => void;
};

const withdrawStore = create<WithdrawStore>((set) => ({
  withdraw: [],

  setWithdraw: (data: withdrawTypes.Withdraw[]) => set({ withdraw: data }),
  addWithdraw: (data: withdrawTypes.Withdraw) =>
    set((state) => ({ withdraw: [...state.withdraw, data] })),
}));
export default withdrawStore;
